import React from 'react'

import Paragraph from '@/components/atoms/Paragraph'
import Page from '@/components/templates/Page'
import { Colors } from '@/utils'

import { Container, IconWrapper } from './style'

type Props = {
  icon: JSX.Element
  iconWrapperColor: string
  title: string
  description?: string
  footer: JSX.Element | JSX.Element[]
}

const PageWithTextAndIcon = ({ icon, iconWrapperColor, title, description, footer }: Props) => (
  <Page footer={footer}>
    <Container>
      <IconWrapper color={iconWrapperColor}>{icon}</IconWrapper>

      <div>
        <Paragraph
          variant="sora"
          fontWeight={600}
          fontSize="24px"
          lineHeight="30px"
          color={Colors.GRAY500}
          textAlign="center"
        >
          {title}
        </Paragraph>
        <Paragraph
          variant="inter"
          fontWeight={500}
          fontSize="14px"
          lineHeight="17px"
          color={Colors.GRAY400}
          textAlign="left"
        >
          {description}
        </Paragraph>
      </div>
    </Container>
  </Page>
)

export default PageWithTextAndIcon
